//自定义过滤器
/**
 *
 * @description 扩充Date对象原型，使其支持日期时间格式化
 * @param {*} fmt 需要格式化的样式 例如yyyy-MM-dd hh:mm:ss
 * @returns 格式化之后的时间
 */

Date.prototype.Format = function (fmt) {
  var o = {
    "y+": this.getFullYear(),
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S+": this.getMilliseconds() //毫秒
  };
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      if (k == "y+") {
        fmt = fmt.replace(RegExp.$1, ("" + o[k]).substr(4 - RegExp.$1.length));
      } else if (k == "S+") {
        var lens = RegExp.$1.length;
        lens = lens == 1 ? 3 : lens;
        fmt = fmt.replace(RegExp.$1, ("00" + o[k]).substr(("" + o[k]).length - 1, lens));
      } else {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
  }
  return fmt;
}


const datetimeFormater = (timestamp, fmt) => {
  let date = new Date(timestamp)
  return date.Format(fmt)
}

/**
 *
 * @description  对数字进行分位
 * @param {*} num 传入的需要分位的数字
 * @param {number} [bit=3] 百分位传2 千分位3 万分位4
 * @returns
 */
const thousandNumFilter = (num, bit = 3) => {
  let ptn = new RegExp(`(\d)(?=(\d{${bit}})+$)`, 'g')
  return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
    return n.replace(ptn, function ($1) { // 对整数部分添加分隔符
      return $1 + ",";
    });
  });
}

const percentFormater = num => {
  return num + '%'
}


export default {
  datetimeFormater,
  thousandNumFilter,
  percentFormater
}


// WEBPACK FOOTER //
// ./src/filters/index.js